import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import CheckboxWithLabelSmily from "@Components/atoms/CheckboxWithLabelSmily";
import { useBreakpoint } from "@Hooks/useBreakpoint";
import { FormError } from "@Types/error";
import { getInputErrorMessages } from "@Utils/error";
import CheckoutCreditCardInput from "./CheckoutCreditCardInput";
import "./style.scss";

interface Props {
  disabled: boolean;
  enableRememberCreditCard: boolean;
  hasCheckedRememberCreditCard: boolean;
  onRememberCreditCard: () => void;
  paymentErrors: FormError[];
}

const CheckoutCreditCardPaymentForm: FunctionComponent<Props> = ({
  disabled,
  enableRememberCreditCard,
  hasCheckedRememberCreditCard,
  onRememberCreditCard,
  paymentErrors,
}) => {
  const { isSmallScreen } = useBreakpoint();
  const intl = useIntl();

  return (
    <form action="" className="CheckoutCreditCardPaymentForm" id="PaymentForm" method="POST">
      <CheckoutCreditCardInput
        disabled={disabled}
        errorMessage={getInputErrorMessages(paymentErrors, "name")}
        id="cardholdername"
        label={intl.formatMessage({
          id: "cheerz_CheckoutCreditCardPaymentForm_placeholder__name",
        })}
        placeholder=""
      />

      <CheckoutCreditCardInput
        disabled={disabled}
        errorMessage={getInputErrorMessages(paymentErrors, "number")}
        id="cc-number"
        label={intl.formatMessage({
          id: "cheerz_CheckoutCreditCardPaymentForm_placeholder__number",
        })}
        placeholder="0000 0000 0000 0000"
      />

      <CheckoutCreditCardInput
        disabled={disabled}
        errorMessage={getInputErrorMessages(paymentErrors, "date")}
        id="cc-exp"
        label={
          isSmallScreen
            ? intl.formatMessage({
                id: "cheerz_CheckoutCreditCardPaymentForm_placeholder__date_short",
              })
            : intl.formatMessage({
                id: "cheerz_CheckoutCreditCardPaymentForm_placeholder__date",
              })
        }
        placeholder="00 / 00"
      />

      <CheckoutCreditCardInput
        disabled={disabled}
        displayHelpInformation={true}
        errorMessage={getInputErrorMessages(paymentErrors, "cvc")}
        id="cc-cvc"
        label={intl.formatMessage({
          id: "cheerz_CheckoutCreditCardPaymentForm_placeholder__cvv",
        })}
        placeholder="000"
      />

      {enableRememberCreditCard && (
        <CheckboxWithLabelSmily
          checked={hasCheckedRememberCreditCard}
          label={intl.formatMessage({ id: "cheerz_CheckoutCreditCardPaymentForm_save_card" })}
          onChange={onRememberCreditCard}
          size="s"
          type="primary"
        />
      )}
    </form>
  );
};

export default CheckoutCreditCardPaymentForm;
